<i18n>
  {
    "fr": {
      "placeholder": "utilisateur@mail.com",
      "label": "E-mail",
      "errors": {
        "email": "Mauvais format de courriel",
        "required": "Champ requis"
      }
    },
    "en": {
      "placeholder": "user@mail.com",
      "label": "E-mail",
      "errors": {
        "email": "Wrong e-mail format",
        "required": "Required field"
      }
    }
  }
</i18n>

<template>
  <v-text-field
    v-model="email"
    :error-messages="emailErrors"
    :placeholder="$t('placeholder')"
    :label="$t('label')"
    required
    outlined
    height="42px"
    dense
    @input="emailTouch"
    @blur="emailTouch"
  >
    <template
      #label
    >
      {{ $t('label' ) }}
      <span
        v-if="!email"
        class="red--text"
      >
        <strong> *</strong>
      </span>
    </template>
  </v-text-field>
</template>

<script>
import _ from 'lodash'
import { mapMutations, mapGetters, mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'FlightCustomerContactMail',
  mixins: [validationMixin],
  computed: {
    ...mapState({
      contactEmail: state => state.fb.passengersInformation.contactEmail
    }),
    ...mapGetters({
      getCustomer: 'general/getCustomer'
    }),
    email: {
      /**
       * Return vueX store state
       * @return {string}
       */
      get () {
        return this.contactEmail
      },
      /**
       * Call a vuelidate touch and call to a debounced method who change vueX state value
       * @param newValue {string}
       */
      set (newValue) {
        this.emailTouch()
        this.changeContactEmailDebounce(newValue)
      }
    },
    /**
     * Return an array of string with errors or nothing based on vuelidate state
     * @return {string[]}
     */
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push(this.$i18n.t('errors.email'))
      !this.$v.email.required && errors.push(this.$i18n.t('errors.required'))
      return errors
    },
    /**
     * Return the opposite of vuelidate invalid parameters (to improve readability of code)
     * This value need to be computed for the watcher to work properly
     * @return {boolean}
     */
    validity () {
      return !this.$v.$invalid
    }
  },
  watch: {
    /**
     * Watch for value change of validity then commit the new value to the store
     * @param newVal {boolean}
     */
    validity (newVal) {
      this.changeContactEmailValidity(newVal)
    }
  },
  validations: {
    email: { required, email }
  },
  created () {
    this.initEmail()
  },
  methods: {
    ...mapMutations({
      changeContactEmail: 'fb/passengersInformation/changeContactEmail',
      changeContactEmailValidity: 'fb/passengersInformation/changeContactEmailValidity'
    }),
    /**
     * A simple debounced vuelidate $touch method
     * @return {undefined}
     */
    emailTouch: _.debounce(function () {
      this.$v.email.$touch()
    }, 600),
    /**
     * A simple debounced vuelidate $touch method
     * @return {undefined}
     */
    changeContactEmailDebounce: _.debounce(function (newValue) {
      this.changeContactEmail(newValue)
    }, 600),
    /**
     * Try to assign a value to email data based on the customer object from vueX store
     * @return {undefined}
     */
    initEmail () {
      if (this.getCustomer.email) {
        this.email = this.getCustomer.email
      }
    }
  }
}
</script>
